import React from "react";
import { Navigate } from 'react-router-dom';
import { useSelector } from "react-redux";

const Profile = () => {
  const { user: currentUser } = useSelector((state) => state.auth);

   let dynText = "";
 
   if(currentUser.roles.includes("ROLE_ADMIN") )
    {
      dynText = "WELCOME DYN ADMIN";
    }
    if(currentUser.roles.includes("ROLE_ADM") )
      {
        dynText = "WELCOME DYN ADM";
      }
    else if(currentUser.roles.includes("ROLE_CUSTOMER") )
    {
      dynText = "WELCOME DYN CUSTOMER";
    }
    else if(currentUser.roles.includes("ROLE_EMPLOYEE") )
    {
      dynText = "WELCOME DYN EMPLOYEE";
    }
    else if(currentUser.roles.includes("ROLE_MAINVO") )
    {
      dynText = "WELCOME DYN MAINVO";
    }
    else if(currentUser.roles.includes("ROLE_SUBVO") )
    {
      dynText = "WELCOME DYN SUBVOS";
    }

  if (!currentUser) {
    return <Navigate to="/login" />;
  }

  return (
    <div className="myn-legal">
      <div className="myn-card">
        <span className="myn-eyebrow">Mein Profil</span>
        <h1 className="myn-h2" style={{ marginBottom: "0.25rem" }}>
          {currentUser.username}
        </h1>
        <p className="myn-text-muted" style={{ marginTop: 0 }}>{dynText}</p>

        <div className="myn-prose" style={{ marginTop: "1.25rem" }}>
          <p>
            <strong>ID:</strong> {currentUser.id}
          </p>
          <p>
            <strong>E-Mail:</strong> {currentUser.email}
          </p>
          <p style={{ wordBreak: "break-all" }}>
            <strong>Token:</strong> {currentUser.accessToken.substring(0, 20)} ...{" "}
            {currentUser.accessToken.substr(currentUser.accessToken.length - 20)}
          </p>

          <h2>Berechtigungen</h2>
          <ul className="myn-roles">
            {currentUser.roles &&
              currentUser.roles.map((role, index) => <li key={index}>{role}</li>)}
          </ul>
        </div>
      </div>
    </div>
  );
};

export default Profile;
